import React, { PureComponent } from "react";
import fetchHandler from "@/fetch/fetchHandler";
import { getDDuserList, addUserFromDing, getDepartmentList, getUserListFromDepartment } from "@/fetch/fetchApi";
import { closeModals } from "@/state/action/comAction";
import PropTypes from "prop-types";
import RefreshGrid from "@/utils/refreshGrid";
import { Tree, message } from "antd";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
const { TreeNode } = Tree;

// eslint-disable-next-line arrow-parens
@connect(state => state)
class AddAccountModal extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.addAccountModal;
    this.state = {
      tableConfig: null,
      expandedKeys: [],
      autoExpandParent: true,
      nameList: [],
      dataSource: [],
    };
  }

  componentWillMount() {
    this.formConfig = {
      childItems: [
        {
          type: "input", // 定义表单元素基础类型
          inputType: "text", // 定义表单元素的子类型
          param: { // 定义表单元素的参数对象
            name: "name", // 参数名称
            type: "string", // 参数类型，用来做类型检测
          },
          required: true,
          placeholder: this.internationalization.placeholder1, // '请先查询用户名称',
          labelName: this.internationalization.title1, // '用户名称', // label名称
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              text: this.internationalization.btn1, // '查询',
              // icon: 'search'
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "searchDDTable",
    };
    this.generateSchema();

    this.handleGetDepartmentList();
  }

  handleGetDepartmentList = () => {
    fetchHandler(getDepartmentList).then((res) => {
      if (res && res.code === "success") {
        this.setState({
          dataSource: res.data,
        });
      }
    });
  }

  // 表格列的定义
  generateSchema() {
    this.setState({
      tableConfig: {
        tableKey: "searchDDTable",
        tableColumns: [
          {
            name: this.internationalization.title1, // '用户名称',
            key: "name",
            colType: "textCol",
            align: "center",
          },
          {
            name: this.internationalization.title2, // '电话',
            key: "phone",
            colType: "textCol",
            align: "center",
          },
          {
            name: this.internationalization.title3, // '邮箱',
            key: "email",
            colType: "textCol",
          },
          {
            name: this.internationalization.action, // '操作',
            key: "action",
            colType: "action",
            align: "center",
            actionMap: [
              {
                type: "confirm",
                actionName: this.internationalization.btn2, // '添加', // 默认actionName
                // 根据grid数据 自定义显示actionName
                // handler: (res) => {
                //   fetchHandler(addUser, res).then((res) => {
                //     if (res.code === 'success') {
                //       this.context.store.dispatch(closeModals('addUserModal'));
                //       RefreshGrid(this.context.store, 'accountTable');
                //     }
                //   });
                // }
              },
            ],
          },
        ],
        tableParam: {
          pagecount: 10,
        },
        dataApi: getDDuserList, // 可配置接口请求函数{getRoleList} 或者 静态数据数组
        autoRefresh: !1, // 设置为true 直接加载grid数据
      },
    });
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  renderTreeNodes = (data) => {
    return data.map((item) => {
      const people = item.people ? item.people.map((v) => {
        return {
          ...v,
          isUser: true,
        };
      }) : [];
      const children = [
        ...(item.children || []),
        ...people,
      ];
      if (children && children.length > 0) {
        return (
          <TreeNode title={item.name} key={item.id} dataRef={item}>
            {this.renderTreeNodes(children)}
          </TreeNode>
        );
      }
      if (item.isUser) {
        return (
          <TreeNode
            key={item.userid}
            isLeaf
            title={(
              <div style={{ display: "flex", width: "150px", justifyContent: "space-between" }}>
                <span>{item.name}</span>
                <a onClick={() => {
                  fetchHandler(addUserFromDing, { userId: item.userid }).then((res) => {
                    if (res.code === "success") {
                      this.context.store.dispatch(closeModals("addUserModal"));
                      RefreshGrid(this.context.store, "accountTable");
                      message.success(this.internationalization.msg1);
                    }
                  });
                }}>{ this.internationalization.btn2}
                </a>
              </div>
          )} />
        );
      } else {
        return (
          <TreeNode key={item.id} title={item.name} dataRef={item} />
        );
      }
    });
  }

  onExpand = async (expandedKeys, { node }) => {
    await this.setState({
      nameList: [node.props.dataRef.name],
    });
    await this.getNameList(node.props.dataRef.id, this.state.dataSource);

    this.setState({
      expandedKeys,
      autoExpandParent: false,
    });
  };

  onLoadData = (treeNode) => {
    if (treeNode.props.isLeaf) {
      return;
    }
    return new Promise((resolve) => {
      if (!treeNode.props.dataRef.people) {
        fetchHandler(getUserListFromDepartment, {
          departId: treeNode.props.dataRef.id,
        }).then((res) => {
          if (res && res.code === "success") {
            treeNode.props.dataRef.people = res.data;
            this.setState({
              dataSource: [...this.state.dataSource],
            });
            resolve();
          }
        });
      }
    });
  }

  // 迭代获取 所有父节点名字
  getNameList = (key, src, parentNode) => {
    src.forEach((v) => {
      if (v.id === key && parentNode) {
        this.state.nameList.unshift(parentNode.name);
        this.setState({
          nameList: this.state.nameList,
        });
        this.getNameList(parentNode.id, this.state.dataSource);
      } else if (v.children && v.children.length > 0) {
        this.getNameList(key, v.children, v);
      }
    });
  }

  renderTittle = () => {
    const items = React.Children.map(this.state.nameList, (child, index) => {
      if (index === this.state.nameList.length - 1) {
        return <span style={{ fontWeight: "bold" }}>{child}</span>;
      } else {
        return <span>{child} /</span>;
      }
    });
    return <div style={{ position: "absolute", top: "15px", left: "100px", fontSize: "16px", width: "650px", overflow: "auto", textOverflow: "ellipsis" }}>{items}</div>;
  }

  render() {
    return (
      <div style={{ height: "500px", overflow: "auto" }}>
        <Tree
          autoExpandParent={this.state.autoExpandParent}
          onExpand={this.onExpand}
          expandedKeys={this.state.expandedKeys}
          loadData={this.onLoadData}
          selectable={false}
      >
          {this.renderTreeNodes(this.state.dataSource)}
        </Tree>
      </div>);
  }
}

export default injectIntl(AddAccountModal);



// WEBPACK FOOTER //
// ./src/AntD/pages/system/account/addAccountModal.js